export const isValidEmail = (value) => {
  if (!value) {
    return true;
  }

  if (value.includes(' ')) {
    return false;
  }

  const atIndex = value.indexOf('@');
  if (atIndex <= 0 || atIndex !== value.lastIndexOf('@')) {
    return false;
  }

  const domain = value.slice(atIndex + 1);
  if (!domain || domain.startsWith('.') || domain.endsWith('.')) {
    return false;
  }

  const parts = domain.split('.');
  return parts.length > 1 && parts.every((part) => part.length > 0);
};
